import { useTranslation } from "react-i18next";
import { formatAmount, printPaginationFooter } from "./helper";
import { statisticsFormatDate } from "./../../utils/helper";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "../primitives";

const BsrTable = (props) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.no")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.fileDate")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.creditCount")}
            </TableCell>
            <TableCell align="right">
              {t("erps.statisticsEnquiry.page.label.creditAmount")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.billerauditNo")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.settlementCount")}
            </TableCell>
            <TableCell align="right">
              {t("erps.statisticsEnquiry.page.label.settlementAmount")}
            </TableCell>
            <TableCell align="left">
              {t("erps.statisticsEnquiry.page.label.settlementauditNo")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.pageData.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="left">{row?.id - 1}</TableCell>
              <TableCell align="left">
                {statisticsFormatDate(row?.fileDate)}
              </TableCell>
              <TableCell align="left">{row?.creditCount}</TableCell>
              <TableCell align="right">
                {formatAmount(row?.creditAmount)}
              </TableCell>
              <TableCell align="left">{row?.auditNumber2}</TableCell>
              <TableCell align="left">{row?.totalSettlementCount}</TableCell>
              <TableCell align="right">
                {formatAmount(row?.settlementAmount)}
              </TableCell>
              <TableCell align="left">{row?.auditNumber}</TableCell>
            </TableRow>
          ))}
          {props.initialDataLength > 100 && (
            <TableRow key="paginate-footer">
              <TableCell colSpan={8} align="right">
                {printPaginationFooter(
                  props.rowPerPage,
                  props.pageNumber,
                  props.initialDataLength
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BsrTable;
